(function () {
    const filters = document.querySelectorAll('.filters__opener');
    filters.forEach(filter => {
        filter.addEventListener('click', function () {
            this.parentNode.classList.toggle('opened');
        })
    })
})()